import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";


export default class SlickSlider {

  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 各スライダー登録
   */
  init() {
    this.slickGallery();
    this.slickSliderRoom();
  }


  slickGallery() {
    // if ($('.c-gallery-slider').length < 0) {
    //   return false;
    // }

      $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        infinite: true,
        asNavFor: '.slider-nav',
        nextArrow:	'<div class="slick-prev"><img src="./assets/images/icon-gallery-prev@2x.png" alt="前へ"/></div>',
        prevArrow:	'<div class="slick-next"><img src="./assets/images/icon-gallery-next@2x.png" alt="次へ"/></div>'

      });
      $('.slider-nav').slick({
        slidesToShow: 5,
        item: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: true,
        infinite: true,
        arrow: false,
        centerMode: false,
        focusOnSelect: true,

        responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
          }
        }, {
          breakpoint: 950,
          settings: {
            slidesToShow: 3,
          }
        }]
      });
  }

  slickSliderRoom() {
    var slider = '.js-slider';
    var thumbItem = '.js-thumb-item';
    var sliderMain = "";
    var thumb = '.js-thumb';

    $('.js-slider-main').each(function (i, elm) {
      var $slider_area = $(elm).parent();
      var $main_slide = $slider_area.find(".js-slider-main");
      var $thumb_slide = $slider_area.find(".js-thumb");


      // データ属性の数字を割り振る
      $thumb_slide.find('.js-thumb-item').each(function () {
        var index = $thumb_slide.find('.js-thumb-item').index(this);
        $(this).attr("data-index", index);
      });

      // 初期化
      $main_slide.on('init', function (slick) {
        $thumb_slide.find(".js-thumb-item:first-child").addClass('thumb-current');
      });

      // サムネイルをクリックした時スライダー切り替え
      $thumb_slide.find(".js-thumb-item").on('click', function () {
        var index = $(this).attr("data-index");
        $main_slide.slick("slickGoTo", index, false);
      });

      // サムネイル画像のカレントを切り替え
      $main_slide.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $thumb_slide.find(".js-thumb-item").removeClass("thumb-current");
        console.log(currentSlide);
        $thumb_slide.find('.js-thumb-item[data-index="' + nextSlide + '"]').addClass("thumb-current");
      });

      // オプション
      $main_slide.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        accessibility: false,
        dots: false,
        arrows: false,
        fade: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {}
          },
        ]
      });
    });
  }

  // 複製して作業
  myCode() {
    console.log("Hello World");
  }
}
